import { defineMessages } from 'react-intl'

export default defineMessages({
  or: {
    id: 'Divider.or',
    defaultMessage: 'or',
  },
})
